export const institutions = [
  {
    name: 'Université de Chypre',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-02-13T03%3A07%3A55.275Z?alt=media&token=0f54a546-693f-4f2e-8d2d-598d457f0cd3',
    id: 111,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'IF Egypte - (test)',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-05-25T13%3A50%3A30.671Z?alt=media&token=fa7fad85-6a4c-4ae5-86af-dab20f0724f9',
    id: 99,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Alliances Françaises du Brésil',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-11-05T22%3A32%3A04.960Z?alt=media&token=a07709cb-a8de-4d0f-bd75-a693c179e1b2',
    id: 101,
    __typename: 'institutions'
  },
  {
    name: 'Alliance Française Lisbonne',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-03-20T19%3A10%3A47.563Z?alt=media&token=53fbfdd7-e1ea-4082-b2f5-b92adbb0a4ee',
    id: 112,
    __typename: 'institutions'
  },
  {
    id: 229,
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2025-03-28T14%3A30%3A58.679Z?alt=media&token=9fba62b8-5595-4991-ab82-1229931a1eb6',
    name: "Institut français d'Allemage"
  },
  {
    name: 'Alliance française Madrid',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-09-16T11%3A49%3A54.379Z?alt=media&token=e1a9dead-cab3-4d32-b689-cff780e931fe',
    id: 102,
    __typename: 'institutions'
  },
  {
    name: 'Esprit Francophonie',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-05-12T02%3A26%3A27.981Z?alt=media&token=d79361ec-3dbe-4cda-875c-b610c6fb4183',
    id: 96,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Alianza Francesa Buenos Aires',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-11-18T05%3A31%3A45.824Z?alt=media&token=97762926-e27f-4439-ba70-226d1a5afab0',
    id: 100,
    __typename: 'institutions'
  },
  {
    name: 'Établissement test Polylearn',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-02-14T09%3A17%3A13.309Z?alt=media&token=bcc2cb33-628c-40a5-abeb-6860a7e219fc',
    id: 92,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Canadian College',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-12-23T23%3A15%3A14.373Z?alt=media&token=b6edbd93-29b0-46f2-b66f-d255f539363c',
    id: 224,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Catalunya',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-12-21T03%3A46%3A43.152Z?alt=media&token=f80d8f8b-4d45-4df0-a531-1dc97e19fc4b',
    id: 109,
    __typename: 'institutions'
  },
  {
    name: 'CENTRE DE LANGUES',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-05-23T08%3A44%3A50.839Z?alt=media&token=a95d48cf-2c4a-433d-a636-dc452a666b47',
    id: 97,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Universidad del norte - Colombia',
    logo: '',
    id: 107,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Institut français du Maroc',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-05-02T15%3A03%3A25.817Z?alt=media&token=fc8a053d-6e2b-4cc9-b4e4-b70499d643e2',
    id: 115,
    __typename: 'institutions'
  },
  {
    name: 'Institut Français Vietnam (archived)',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-12-27T01%3A03%3A09.331Z?alt=media&token=43114432-044a-4471-acdb-8d851c3b3af8',
    id: 118,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Alliance française Santiago de Compostela (archived)',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-09-11T21%3A42%3A31.342Z?alt=media&token=aea64342-d29f-4393-9842-a5e665a6d505',
    id: 138,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Institut Français Vietnam',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-12-27T01%3A03%3A09.331Z?alt=media&token=43114432-044a-4471-acdb-8d851c3b3af8',
    id: 110,
    __typename: 'institutions'
  },
  {
    name: 'CENTRE DE LANGUES SÉMINAIRE',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-09-01T21%3A29%3A57.622Z?alt=media&token=2705d4bd-dc7c-4a29-9819-e87ab7d23cc7',
    id: 129,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Institut français de Corée ',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-03-10T19%3A59%3A46.914Z?alt=media&token=38214985-ee8a-416b-b63a-e32a0a3ce8fa',
    id: 126,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Mexico',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-08-09T00%3A01%3A37.438Z?alt=media&token=788bbdec-3c51-4745-a553-06204e3dbb60',
    id: 127,
    __typename: 'institutions'
  },
  {
    name: 'Alliance francaise Malaga',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-06-19T23%3A30%3A17.747Z?alt=media&token=2fb3410a-3abb-4d51-8529-2469ee7661f1',
    id: 124,
    __typename: 'institutions'
  },
  {
    name: 'Alliance Française San Luis Potosi',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-03-30T12%3A19%3A40.382Z?alt=media&token=86594ec4-b37e-4929-a1ef-d53784af32c0',
    id: 114,
    __typename: 'institutions'
  },
  {
    name: 'Institut français de Turquie',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-05-16T16%3A35%3A45.458Z?alt=media&token=818d8bf1-f73a-4377-bd0b-c112125bf48b',
    id: 116,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Guimaraes',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-03-23T13%3A14%3A30.095Z?alt=media&token=aa4ea479-0a7e-41c2-a77c-87411a892ea8',
    id: 113,
    __typename: 'institutions'
  },
  {
    name: 'Institut français de Turquie (archived)',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-05-16T17%3A01%3A03.275Z?alt=media&token=edf2da8b-b76e-4db9-922b-bc3c17e1d414',
    id: 117,
    __typename: 'institutions'
  },
  {
    name: 'Institut français du Cambodge',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-02-07T14%3A58%3A21.470Z?alt=media&token=13a03d4b-ea5c-4119-b488-b61303b81579',
    id: 167,
    __typename: 'institutions'
  },
  {
    name: 'Alliance Française Las Palmas de Gran Canaria',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-02-27T20%3A06%3A10.562Z?alt=media&token=5a58394d-33de-4494-aded-d421e0f12e8d',
    id: 172,
    __typename: 'institutions'
  },
  {
    name: "Alliance française de l'Algarve (archived)",
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-10-19T22%3A39%3A32.143Z?alt=media&token=fee57ff5-bea5-4889-9235-4b3445f16930',
    id: 150,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'CaribFLE',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-12-03T22%3A46%3A01.852Z?alt=media&token=745d46c8-01ad-4128-a3fb-b3d8df7abf36',
    id: 156,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Santiago de Compostela',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-09-05T22%3A35%3A01.188Z?alt=media&token=c939db94-1495-4bf3-a9ab-b033249eeb36',
    id: 130,
    __typename: 'institutions'
  },
  {
    name: "Alliance française de l'Algarve",
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-10-19T06%3A27%3A53.332Z?alt=media&token=599ca911-3e30-4ee8-b73e-a6d4f848dabb',
    id: 149,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française de Mendoza',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-04-12T06%3A14%3A48.001Z?alt=media&token=9cf0aab6-f0d6-4e8e-adb6-3179d3f588d2',
    id: 173,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Costa Rica',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-09-06T21%3A36%3A54.969Z?alt=media&token=36a54111-b66e-486d-9a1d-6b443e23c2bb',
    id: 132,
    __typename: 'institutions'
  },
  {
    name: 'Ernst Klett Sprachen',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-12-18T20%3A42%3A32.170Z?alt=media&token=ffe3e88e-f791-4f67-8d1e-57d06f3debce',
    id: 159,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Books & Books',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-01-18T08%3A34%3A55.520Z?alt=media&token=83765dd8-6c55-492e-81ca-3889d309b843',
    id: 162,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'AF RIO',
    logo: '',
    id: 191,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'French with Loren',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-11-15T15%3A21%3A27.026Z?alt=media&token=b9c449c9-44be-466a-ab7c-8c9b702180cd',
    id: 178,
    __typename: 'institutions'
  },
  {
    name: 'CLE International',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/6/6d/CLE_-_petit.jpg',
    id: 48,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Institution Demo II',
    logo: '',
    id: 176,
    __typename: 'institutions',
    show: false
  },
  {
    name: 'Institut français Bilbao',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-03-26T13%3A21%3A34.505Z?alt=media&token=1f254c83-89e9-48b5-8bd2-a6a4f30857d7',
    id: 181,
    __typename: 'institutions'
  },
  {
    name: 'Institut français Madrid',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-03-26T13%3A20%3A40.728Z?alt=media&token=22e9c4f9-d10e-419c-9a6c-41515b4f3cbf',
    id: 164,
    __typename: 'institutions'
  },
  {
    name: 'Institut français de Zaragoza',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-03-26T13%3A21%3A01.863Z?alt=media&token=5fd94152-36cd-4742-8f38-03ab38dab1de',
    id: 180,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Córdoba Argentina',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-07-04T18%3A39%3A58.314Z?alt=media&token=04f978fb-af8d-4e45-aa61-e35980411a80',
    id: 196,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française de Porto',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-01-19T09%3A02%3A03.609Z?alt=media&token=ced99dee-742a-45d7-aea0-c00feab1600b',
    id: 163,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Barranquilla',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-07-11T21%3A31%3A04.760Z?alt=media&token=721f51bd-0592-4dbe-b283-93dea71a767b',
    id: 197,
    __typename: 'institutions'
  },
  {
    name: 'Instituto lengua francesa Sevilla',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-06-05T06%3A14%3A47.492Z?alt=media&token=ac9ecbc2-3fd4-4fa5-b1a1-fec17c401999',
    id: 195,
    __typename: 'institutions'
  },
  {
    name: 'Alliance Francaise Puebla Mex',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2022-05-06T20%3A16%3A09.803Z?alt=media&token=d0cf0166-447a-4034-9523-a96c8362f050',
    id: 95,
    __typename: 'institutions'
  },
  {
    name: 'Institut français de Barcelone',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-03-26T13%3A21%3A20.351Z?alt=media&token=c2cc0f47-0c3c-41f2-88ce-170605f5d82e',
    id: 179,
    __typename: 'institutions'
  },
  {
    name: 'Polyglot',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-02-29T14%3A50%3A22.386Z?alt=media&token=4df5d1b1-b4a8-4bf1-8cc4-33f08450f0a1',
    id: 174,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Taiwan',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-07-16T13%3A17%3A58.645Z?alt=media&token=2a84a423-e4de-4a1b-9863-eef85bbfb61c',
    id: 198,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française de Lille',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-04-03T14%3A00%3A03.088Z?alt=media&token=0e751d2e-8cc7-4e6b-8203-85f9859c1c66',
    id: 182,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Cuenca - Ecuador',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-09-07T13%3A32%3A32.233Z?alt=media&token=9290a3ab-35e1-43d3-8620-c3f068dcda91',
    id: 199,
    __typename: 'institutions'
  },
  {
    name: 'Alliance française Rosario',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-11-25T21%3A17%3A22.928Z?alt=media&token=6d5be1b6-2029-419a-97f7-4e15739c2eb2',
    id: 219,
    __typename: 'institutions'
  },
  {
    name: 'Escuela Sierra Nevada',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-09-23T19%3A19%3A25.191Z?alt=media&token=72f4096f-54fb-4639-acd4-7be6bf51604f',
    id: 201,
    __typename: 'institutions'
  },
  {
    name: 'ASPLEF',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-10-28T15%3A14%3A16.355Z?alt=media&token=2338e095-aa8a-4846-bc96-d3e0932ae182',
    id: 208,
    __typename: 'institutions'
  },
  {
    name: 'Institut français de Pologne - Cracovie',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2024-10-21T14%3A42%3A58.730Z?alt=media&token=dc7f7912-9a68-480e-8e9b-be65ae481343',
    id: 205,
    __typename: 'institutions'
  },
  {
    name: 'Institut Francais Italia',
    logo:
      'https://firebasestorage.googleapis.com/v0/b/toeic-new-design.appspot.com/o/institutions%2F2023-03-16T21%3A31%3A58.635Z?alt=media&token=202aba08-fdc5-4285-92a8-2ed89a931a15',
    id: 98,
    __typename: 'institutions'
  }
];
